import React, { useState, useContext, useEffect } from 'react';
import { LanguageContext } from "../../context/LanguageContext";
// const AiProjectsSectionVideo = ({
//   videoId = "jssO8-5qmag",
//   embedUrl = "https://www.youtube.com/embed/WZJoxikns4Q?si=Yk2nwDbnx5x0sOij"
// })
const AiProjectsSectionVideo = ({
  // videoSrc = "/mas_ai_zh.mp4" // 這裡用 public 資料夾相對路徑
}) => {
  const [isPlaying, setIsPlaying] = useState(true);
  const { componentLanguageData, loadLanguageFile, language } = useContext(LanguageContext);
  useEffect(() => {
    loadLanguageFile("AiProjectsSectionVideo", "product/product_ai_video_lang");
  }, [language]);

  const LANGUAGE = componentLanguageData.AiProjectsSectionVideo || { Main: {} };

  const handlePlay = () => {
    setIsPlaying(true);
  };

  return (
    <div className="ai_video">
      <div className="container-fluid">
        <div className="row align-items-center">
          <div className="col-md-6">
            <div id="video-section">
              {!isPlaying ? (
                <div className="youtube-player" onClick={handlePlay}>
                  <div className="video-thumb">
                    <img src="img/portfolio-2.jpg" alt="Video Thumbnail" />
                    <div className="play"></div>
                  </div>
                </div>
              ) : (
                <iframe
                  src={LANGUAGE.Main.EmbedUrl}
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                  style={{ width: "100%", height: "500px" }}
                />
              )}
              {/* {!isPlaying ? (
                <div className="video-thumb" onClick={handlePlay}>
                  <img src="img/portfolio-2.jpg" alt="Video Thumbnail" style={{ width: "100%" }} />
                  <div className="play"></div>
                </div>
              ) : (
                <video
                  src={videoSrc}
                  controls
                  autoPlay
                  muted
                  playsInline
                  style={{ width: "100%", height: "500px" }}
                />
              )} */}
            </div>
          </div>
          <div className="col-md-6">
            <h1 className="section-title mt-3">{LANGUAGE.Main.Content1}</h1>
            <p>{LANGUAGE.Main.Content2}</p>
            <ul className="ai-check-list">
              <li>{LANGUAGE.Main.Item1}</li>
              <li>{LANGUAGE.Main.Item2}</li>
              <li>{LANGUAGE.Main.Item3}</li>
              <li>{LANGUAGE.Main.Item4}</li>
              <li>{LANGUAGE.Main.Item5}</li>
              <li>{LANGUAGE.Main.Item6}</li>
              <li>{LANGUAGE.Main.Item7}</li>
            </ul>
            <p>{LANGUAGE.Main.Content3}</p>
            <a className="btn btn-primary btn-outline-primary" href={process.env.REACT_APP_SIGNIN_URL || "https://trade.masquant.com/authentication/sign-in"}>
              {LANGUAGE.Main.CTA}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AiProjectsSectionVideo;
